/* wrapper.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./wrapper.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var wrapperStyles = null;
export var ImageRendererWrapper = function ImageRendererWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "ImageRendererWrapper",
    className: ax(["_kqswstnw _1bsb1osq _4t3i1osq _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o"])
  }, children);
};